"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var date_1 = require("../utils/date");
var DynamicQuery = /** @class */ (function (_super) {
    __extends(DynamicQuery, _super);
    function DynamicQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DynamicQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
    };
    DynamicQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, key = _a.key, keyQuery = _a.keyQuery, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ keyQuery: keyQuery, key: key }, (options.dynamic || {}));
    };
    DynamicQuery.prototype.getRawValue = function (executionOptions) {
        var key = this.options.key;
        var response;
        switch (key) {
            case 'date':
                response = date_1.getUTCDateString();
                break;
            case 'year':
                response = date_1.getUTCFullYear();
                break;
            case 'user-agent':
                response = navigator && navigator.userAgent;
                break;
            case 'isoDateTime':
                response = new Date().toISOString();
                break;
        }
        return response;
    };
    return DynamicQuery;
}(BaseQuery_1.BaseQuery));
exports.DynamicQuery = DynamicQuery;
//# sourceMappingURL=DynamicQuery.js.map